// import React, { useEffect, useState } from "react";
// import { useForm } from "react-hook-form";
// import { useParams, useLocation } from "react-router-dom";
// import { Button, Form, FormGroup, Label, FormText, Row, Col, Alert, Table } from "reactstrap";
// import { API_BASE_URL } from "../../../../_services/constant";
// import { Card, TextField } from "@material-ui/core";
// import { post } from "axios";

// import {
//   postMethod,
//   validateMobile,
//   singleParam,
//   editUserGrid,
// } from "../../../../_services/_postMethod";
// import Loader from "../../../modules/loader";
// function useQuery() {
//   return new URLSearchParams(useLocation().search);
// }

// const AddStockacceptance = (props) => {
//   let queryParams = useQuery();
//   const id = queryParams.get("id") == "" ? null : queryParams.get("id");
//   const { register, handleSubmit, errors } = useForm();
//   const [load, setLoad] = useState(false);
//   const [productlist, setProductlist] = useState([]);
//   const [branchlist, setBranchlist] = useState([]);
//   const [stockAcceptanceproducts, setstockAcceptanceproducts] = useState([]);
//   const [stockinproductParam, setStockinproductParam] = useState({
//     product_id: "",
//     product: "",
//     barcode: "",
//     description: "",
//     qty: "",
//     branch_id:""
//   });

//   const [param, setParam] = useState({
//     tran_id: id == null ? "0" : id,   
//     to_branch_id: 0,
//     from_branch_id:0,
//     date: "",
//     entry_no: "",
//     remarks: "",
//     status: "",
//     stock_in_products: [],
//   });
//   const [success, setSuccess] = useState(false);
//   const [successDelete, setSuccessDelete] = useState(false);

//   useEffect(() => {
//     if (id !== null) {
//       setLoad(true);
//       var temp = window.atob(id);
//       postMethod("api/transactions/stockAcceptance/preview", { tran_id: temp }).then((data) => {
//         setParam({
//           ...param,       
//           from_branch_id: data[0][0].from_branch_id,
//           status: data[0][0].status,
//           to_branch_id: data[0][0].to_branch_id,          
//           date: data[0][0].date.split("T")[0],
//           entry_no: data[0][0].entry_no,
//           remarks: data[0][0].remarks,
//           stock_in_products: data[1],
//         });
//         setstockAcceptanceproducts(data[1]);
//         setLoad(false);
//       });
//     }
//     postMethod("api/transactions/stockin/getproductlist", {}).then((data) => {
//       setProductlist(data.data);
//     });

//     postMethod("api/transactions/stockin/getbranchlist", {}).then((data) => {
//       setBranchlist(data.data);
//     });
//   }, []);

//   // check object is null or undefined
//   const checkObject = (obj) => {
//     return obj === undefined ? {} : Object.keys(obj).length === 0 && obj.constructor === Object;
//   };

//   const AddProduct = () => {
//     if (
//       stockinproductParam.product_id !== "" &&
//       (stockinproductParam.barcode !== "") !== "" &&
//       stockinproductParam.qty !== ""
//     ) {
//       stockAcceptanceproducts.push(stockinproductParam);
//       setStockinproductParam({
//         product_id: "",
//         product: "",
//         barcode: "",
//         qty: "",
//       });
//     }
//   };
//   const removeProduct = (i) => {
//     let tempArry = [...stockAcceptanceproducts];
//     tempArry.splice(i, 1);
//     setstockAcceptanceproducts(tempArry);
//   };

//   const _Save = () => {
//      let tempArrySave = [];
//     let tempArry = [...stockAcceptanceproducts];
//       tempArry.forEach(Obj => { 
//       if(Obj.accept == true)
//       {
//         tempArrySave.push({product_id:Obj.product_id,stp_id:Obj.tran_id,qty:Obj.rec_qty});
//       }
//       }); 

//     var temp = id == null ? "0" : window.atob(id);
//     let temparam = {
//       tran_id:0,
//       from_branch_id: param.from_branch_id, 
//       st_id: temp, 
//       date: param.date,
//       entry_no: param.entry_no,
//       remarks: param.remarks,
//       stock_acceptance_products: tempArrySave  
//     };
//     postMethod("api/transactions/stockAcceptance/insert", temparam).then((data) => {
//       if (data.valid) {
//         setSuccess(true);
//         setTimeout(() => {
//           props.history.push("/branch/stock-acceptance");
//         }, 2000);
//       }
//     });
//   };
//   const handleDelete = () => {
//     var proceed = window.confirm("Do you Really Wish to Delete this Entry..?!");
//     var temp = window.atob(id);
//     if (proceed) {
//       postMethod("api/transactions/stockAcceptance/delete", { tran_id: temp }).then((data) => {
//         console.log(data);
//         if (data.valid) {
//           setSuccessDelete(true);
//           setTimeout(() => {
//             props.history.push("/branch/stock-acceptance");
//           }, 2000);
//         }
//       });
//     }
//   };

//   return (
//     <>
//       {load ? <Loader /> : null}
//       <Form onSubmit={handleSubmit(_Save)}>
//         <input
//           type="hidden"
//           name="product_id"
//           value={id == null ? "0" : param.product_id}
//           ref={register}
//         />
//         <div className="card card-custom gutter-b">
//           <div className="card-header">
//             <div className="card-title">
//               <h3 className="card-label">Add Stock Acceptance</h3>
//             </div>
//           </div>
//           <div className="card-body">
//             <Row>
//               <Col sm={3}>
//                 <FormGroup>
//                   <Label>Date</Label>
//                   <TextField
//                     type="date"
//                     value={param.date}
//                     className="form-control"
//                     onChange={(e) => {
//                       setParam({
//                         ...param,
//                         date: e.target.value,
//                       });
//                     }}
//                     InputLabelProps={{
//                       shrink: true,
//                     }}
//                   />
//                 </FormGroup>
//               </Col>
//               <Col sm={3}>
//                 <FormGroup>
//                   <Label>Entry No</Label>
//                   <input
//                     type="text"
//                     required
//                     value={param.entry_no}
//                     className="form-control h-auto py-2 px-6"
//                     name="entry_no"
//                     onChange={(e) => setParam({ ...param, entry_no: e.target.value })}
//                     ref={register}
//                   />
//                 </FormGroup>
//               </Col> 
//               <Col sm={12}>
//                 <FormGroup>
//                   <Label>Remarks</Label>
//                   <input
//                     type="text"
//                     value={param.remarks}
//                     className="form-control h-auto py-2 px-6"
//                     name="remarks"
//                     onChange={(e) => setParam({ ...param, remarks: e.target.value })}
//                     ref={register}
//                   />
//                 </FormGroup>
//               </Col>
//             </Row>

//             <Row>
//               <Col sm={12}>
//                 <Table bordered>
//                   <thead>
//                     <tr>
//                       <th>Product Code</th>
//                       <th>Product</th>
//                       <th>Image</th>
//                       <th>Qty</th>
//                       {param.status.toUpperCase() == "DONE" || param.status.toUpperCase() == "CANCEL" ? null :  <th>Action</th>}
//                     </tr>                  
//                   </thead>
//                   <tbody>
//                     {checkObject(stockAcceptanceproducts)
//                       ? null
//                       : stockAcceptanceproducts.map((obj, i) => {
//                           return (
//                             <tr key={i}>
//                               <td>
//                                 {i + 1}) {obj.product_code}
//                               </td>
//                               <td>{obj.product}</td>                              
//                               <td><img src={obj.url_image +""+obj.image_path} width="36px" alt="" />   </td>  
//                               <td>{obj.qty}</td>
//                               {param.status.toUpperCase() == "DONE" || param.status.toUpperCase() == "CANCEL" ? null: <td>
//                                  <input
//                                 type="checkbox"                  
//                                 defaultChecked={ obj.accept}
//                                  name="available"
//                                  onChange={(e) => {                               
//                                      stockAcceptanceproducts[i].accept = e.target.checked; 
//                                  }} 
//                                  />
//                               </td>}
//                             </tr>
//                           );
//                         })}
//                   </tbody>
//                 </Table>
//               </Col>
//             </Row>
//             {success ? <Alert color="success">Saved Successfully</Alert> : null}
//             {successDelete ? <Alert color="danger">Entery deleted</Alert> : null}
//           </div>
//           <div className="card-footer text-right">
//             <a href="/branch/stock-acceptance" className="btn btn-secondary mr-2">
//               Cancel
//             </a>
//            {param.status.toUpperCase() == "DONE" || param.status.toUpperCase() == "CANCEL" ? null:  <button type="submit" className="btn btn-primary ">
//               Submit
//             </button>}

//           </div>
//         </div>
//       </Form>
//     </>
//   );
// };

// export default AddStockacceptance;

import React, { useEffect, useState } from "react";
import jsPDF from "jspdf";
import * as XLSX from "xlsx";
import moment from "moment";
import { useForm } from "react-hook-form";
import { useParams, useLocation } from "react-router-dom";
import { Button, Form, FormGroup, Label, FormText, Row, Col, Alert, Table } from "reactstrap";
import { API_BASE_URL } from "../../../../_services/constant";
import { Card, TextField } from "@material-ui/core";
import { post } from "axios";

import {
  postMethod,
  validateMobile,
  singleParam,
  editUserGrid,
} from "../../../../_services/_postMethod";
import Loader from "../../../modules/loader";
import { showSuccessToast, showErrorToast } from "../../../../_services/notification";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const AddStockacceptance = (props) => {
  let queryParams = useQuery();
  const id = queryParams.get("id") == "" ? null : queryParams.get("id");
  const isView = queryParams.get("view") === "true";
  const { register, handleSubmit, errors } = useForm();
  const [load, setLoad] = useState(false);
  const [productlist, setProductlist] = useState([]);
  const [branchlist, setBranchlist] = useState([]);
  const [stockAcceptanceproducts, setstockAcceptanceproducts] = useState([]);
  const [stockinproductParam, setStockinproductParam] = useState({
    product_id: "",
    product: "",
    barcode: "",
    description: "",
    qty: "",
    branch_id: ""
  });

  const [param, setParam] = useState({
    tran_id: id == null ? "0" : id,
    to_branch_id: 0,
    from_branch_id: 0,
    date: "",
    entry_no: "",
    remarks: "",
    status: "",
    stock_in_products: [],
  });

  const [success, setSuccess] = useState(false);
  const [successDelete, setSuccessDelete] = useState(false);
  const [selectAll, setSelectAll] = useState(false);

  useEffect(() => {
    if (id !== null) {
      setLoad(true);
      var temp = window.atob(id);
      postMethod("api/transactions/stockAcceptance/preview", { tran_id: temp }).then((data) => {
        console.log(JSON.stringify(data[1]));
        setParam({
          ...param,
          from_branch_id: data[0][0].from_branch_id,
          status: data[0][0].status,
          to_branch_id: data[0][0].to_branch_id,
          date: data[0][0].date.split("T")[0],
          entry_no: data[0][0].entry_no,
          remarks: data[0][0].remarks,
          stock_in_products: data[1],
        });
        // setstockAcceptanceproducts(data[1]);
        // const products = data[1].map(item => ({
        //   ...item,
        //   accept: item.accept == 1 || item.accept === true
        // }));

        // setstockAcceptanceproducts(products);
        const products = data[1].map(item => ({
          ...item,
          accept: item.accept == 1 || item.accept === true,
          locked: item.accept == 1 || item.accept === true
        }));

        setstockAcceptanceproducts(products);

        const allSelected =
          products.filter(x => !x.locked).length > 0 &&
          products.filter(x => !x.locked).every(x => x.accept);

        setSelectAll(allSelected);
        setLoad(false);
      });
    }
    postMethod("api/transactions/stockin/getproductlist", {}).then((data) => {
      setProductlist(data.data);
    });

    postMethod("api/transactions/stockin/getbranchlist", {}).then((data) => {
      setBranchlist(data.data);
    });
  }, []);

  const checkObject = (obj) => {
    return obj === undefined ? {} : Object.keys(obj).length === 0 && obj.constructor === Object;
  };

  const AddProduct = () => {
    if (
      stockinproductParam.product_id !== "" &&
      (stockinproductParam.barcode !== "") !== "" &&
      stockinproductParam.qty !== ""
    ) {
      stockAcceptanceproducts.push(stockinproductParam);
      setStockinproductParam({
        product_id: "",
        product: "",
        barcode: "",
        qty: "",
      });
    }
  };

  const removeProduct = (i) => {
    let tempArry = [...stockAcceptanceproducts];
    tempArry.splice(i, 1);
    setstockAcceptanceproducts(tempArry);
  };

  const _Save = () => {
    let tempArrySave = [];
    let tempArry = [...stockAcceptanceproducts];
    tempArry.forEach((Obj) => {
      if (Obj.accept === true) {
        // tempArrySave.push({ product_id: Obj.product_id, stp_id: Obj.tran_id, qty: Obj.rec_qty });
        tempArrySave.push({
          product_id: Obj.product_id,
          qty: Obj.transfer_qty
        });
      }
    });

    var temp = id == null ? "0" : window.atob(id);
    let temparam = {
      tran_id: 0,
      from_branch_id: param.from_branch_id,
      st_id: temp,
      date: param.date,
      entry_no: param.entry_no,
      remarks: param.remarks,
      stock_acceptance_products: tempArrySave,
    };
    postMethod("api/transactions/stockAcceptance/insert", temparam).then((data) => {
      if (data.valid) {
        setSuccess(true);
        setTimeout(() => {
          props.history.push("/branch/stock-acceptance");
        }, 2000);
      }
    });
  };

  const handleDelete = () => {
    var proceed = window.confirm("Do you Really Wish to Delete this Entry..?!");
    var temp = window.atob(id);
    if (proceed) {
      postMethod("api/transactions/stockAcceptance/delete", { tran_id: temp }).then((data) => {
        console.log(data);
        if (data.valid) {
          setSuccessDelete(true);
          setTimeout(() => {
            props.history.push("/branch/stock-acceptance");
          }, 2000);
        }
      });
    }
  };

  //   const handleSelectAll = () => {
  //   const checked = !selectAll;

  //   const tempArry = stockAcceptanceproducts.map(item => ({
  //     ...item,
  //     accept: checked,
  //   }));

  //   setstockAcceptanceproducts(tempArry);
  //   setSelectAll(checked);
  // };

  const handleSelectAll = () => {
    const checked = !selectAll;

    const tempArry = stockAcceptanceproducts.map(item => {
      if (item.locked) {
        return item;
      }

      return {
        ...item,
        accept: checked,
      };
    });

    setstockAcceptanceproducts(tempArry);

    const allSelected =
      tempArry.filter(x => !x.locked).length > 0 &&
      tempArry.filter(x => !x.locked).every(x => x.accept);

    setSelectAll(allSelected);
  };

  const getImage = (item) => {
    if (!item) return "";
    let path = item.image_path || "";
    let baseUrl = item.url_image || "https://admin.quicktagg.com/";

    if (item.isImageUrl === true || item.isImageUrl === "true") {
      if (path.startsWith("http://") || path.startsWith("https://") || path.startsWith("data:")) {
        console.log("from start", path)
        return path;
      }
      console.log("from end")

      return baseUrl.replace(/\/$/, "") + "/" + path.replace(/^\//, "");
    }

    if (path.startsWith("http://") || path.startsWith("https://") || path.startsWith("data:")) {
      console.log("from end1")

      return path;
    }

    console.log("from end2")
    return baseUrl.replace(/\/$/, "") + "/" + path.replace(/^\//, "");
  };

  const loadImageAsBase64 = async (src) => {
    if (!src) return null;
    const cleanSrc = src.trim();
    if (cleanSrc.startsWith("data:")) return cleanSrc;

    // 1. Try Direct Fetch
    try {
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 1500);
      const res = await fetch(cleanSrc, { signal: controller.signal });
      clearTimeout(timer);
      if (res.ok) {
        const blob = await res.blob();
        return await new Promise((resolve) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.onerror = () => resolve(null);
          reader.readAsDataURL(blob);
        });
      }
    } catch (e) {}

    // 2. Try CORS Proxy (weserv.nl)
    try {
      const proxyUrl = `https://images.weserv.nl/?url=${encodeURIComponent(cleanSrc)}`;
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 2500);
      const res = await fetch(proxyUrl, { signal: controller.signal });
      clearTimeout(timer);
      if (res.ok) {
        const blob = await res.blob();
        return await new Promise((resolve) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.onerror = () => resolve(null);
          reader.readAsDataURL(blob);
        });
      }
    } catch (e) {}

    // 3. Try Canvas with crossOrigin
    return new Promise((resolve) => {
      const corsSrc = cleanSrc + (cleanSrc.includes("?") ? "&" : "?") + "cb=" + Date.now();
      const img = new Image();
      img.crossOrigin = "anonymous";
      img.onload = () => {
        try {
          const canvas = document.createElement("canvas");
          canvas.width = img.naturalWidth || img.width || 60;
          canvas.height = img.naturalHeight || img.height || 60;
          const ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
          resolve(canvas.toDataURL("image/jpeg", 0.85));
        } catch (e) {
          resolve(null);
        }
      };
      img.onerror = () => resolve(null);
      img.src = corsSrc;
    });
  };

  const exportToExcel = () => {
    try {
      const formattedDate = param.date ? moment(param.date).format("DD-MM-YYYY") : "-";

      const sheetData = [
        ["Entry No.", param.entry_no || "-"],
        ["Date", formattedDate],
        ["Status", param.status || "-"],
        ["Remarks", param.remarks || "-"],
        [],
        [`Stock Acceptance Products (${stockAcceptanceproducts.length} Items)`],
        ["Product Code", "Product", "Size", "Color", "Qty"],
        ...stockAcceptanceproducts.map((item) => [
          item.product_code || "",
          item.product || item.product_name || "",
          item.size_length || "",
          item.color || "",
          item.transfer_qty ?? item.qty ?? "",
        ]),
      ];

      const worksheet = XLSX.utils.aoa_to_sheet(sheetData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Stock_Acceptance");
      const filename = `Stock_Acceptance_${param.entry_no || param.tran_id || "Details"}_${moment().format("DD-MM-YYYY")}.xlsx`;
      XLSX.writeFile(workbook, filename);
      showSuccessToast("Excel downloaded successfully.");
    } catch (err) {
      console.error(err);
      showErrorToast("Error generating Excel file.");
    }
  };

  const exportToPDF = async () => {
    try {
      setLoad(true);
      const pdf = new jsPDF("p", "mm", "a4");
      let y = 15;

      const formattedDate = param.date ? moment(param.date).format("DD-MM-YYYY") : "-";

      pdf.setFontSize(10);
      pdf.setFont(undefined, "normal");
      pdf.text(`Entry No.: ${param.entry_no || "-"}`, 14, y);
      pdf.text(`Date: ${formattedDate}`, 85, y);
      y += 6;
      pdf.text(`Status: ${param.status || "-"}`, 14, y);
      y += 6;
      pdf.text(`Remarks: ${param.remarks || "-"}`, 14, y);
      y += 8;

      pdf.setFont(undefined, "bold");
      pdf.text(`Stock Acceptance Products (${stockAcceptanceproducts.length} Items)`, 14, y);
      y += 6;

      // Table Headers
      pdf.setFontSize(8);
      pdf.setFont(undefined, "bold");
      pdf.setFillColor(240, 243, 246);
      pdf.rect(14, y - 4, 181, 6, "F");

      const colPositions = [15, 55, 100, 125, 150, 175];
      const headers = ["Product Code", "Product", "Size", "Color", "Qty", "Image"];
      headers.forEach((h, idx) => {
        pdf.text(h, colPositions[idx], y);
      });

      y += 4;
      pdf.line(14, y - 1, 195, y - 1);
      y += 4;

      // Pre-load images
      const loadedImages = await Promise.all(
        stockAcceptanceproducts.map((item) => loadImageAsBase64(getImage(item)))
      );

      pdf.setFont(undefined, "normal");
      for (let index = 0; index < stockAcceptanceproducts.length; index++) {
        const item = stockAcceptanceproducts[index];
        const imgData = loadedImages[index];
        const rowHeight = imgData ? 13 : 7;

        if (y + rowHeight > 275) {
          pdf.addPage();
          y = 15;
        }

        const textY = imgData ? y + 5 : y;
        pdf.text(String(item.product_code || "-"), colPositions[0], textY, { maxWidth: 35 });
        pdf.text(String(item.product || item.product_name || "-"), colPositions[1], textY, { maxWidth: 40 });
        pdf.text(String(item.size_length || "-"), colPositions[2], textY, { maxWidth: 20 });
        pdf.text(String(item.color || "-"), colPositions[3], textY, { maxWidth: 20 });
        pdf.text(String(item.transfer_qty ?? item.qty ?? "-"), colPositions[4], textY, { maxWidth: 20 });

        if (imgData) {
          try {
            const format = imgData.includes("image/png") ? "PNG" : "JPEG";
            pdf.addImage(imgData, format, colPositions[5], y, 10, 10);
          } catch (e) {
            pdf.text("-", colPositions[5], textY);
          }
        } else {
          pdf.text("-", colPositions[5], textY);
        }

        y += rowHeight + 2;
      }

      const filename = `Stock_Acceptance_${param.entry_no || param.tran_id || "Details"}_${moment().format("DD-MM-YYYY")}.pdf`;
      pdf.save(filename);
      showSuccessToast("PDF downloaded successfully.");
    } catch (err) {
      console.error(err);
      showErrorToast("Error generating PDF file.");
    } finally {
      setLoad(false);
    }
  };
  return (
    <>
      {load ? <Loader /> : null}
      <Form onSubmit={handleSubmit(_Save)}>
        <input
          type="hidden"
          name="product_id"
          value={id == null ? "0" : param.product_id}
          ref={register}
        />
        <div className="card card-custom gutter-b">
          <div className="card-header d-flex align-items-center justify-content-between flex-wrap">
            <div className="card-title">
              <h3 className="card-label">{isView ? "View" : id != null ? "Edit" : "Add"} Stock Acceptance</h3>
            </div>
            {isView && (
              <div className="d-flex align-items-center flex-wrap mb-2" style={{ gap: "10px" }}>
                <button
                  type="button"
                  className="btn btn-outline-danger btn-sm font-weight-bold py-2 px-3"
                  onClick={exportToPDF}
                >
                  <i className="fa fa-file-pdf-o mr-2"></i> Download PDF
                </button>
                <button
                  type="button"
                  className="btn btn-outline-success btn-sm font-weight-bold py-2 px-3"
                  onClick={exportToExcel}
                >
                  <i className="fa fa-file-excel-o mr-2"></i> Download Excel
                </button>
              </div>
            )}
          </div>
          <div className="card-body">
            <Row>
              <Col sm={3}>
                <FormGroup>
                  <Label>Date</Label>
                  <TextField
                    type="date"
                    value={param.date}
                    className="form-control"
                    disabled={isView}
                    onChange={(e) => {
                      setParam({
                        ...param,
                        date: e.target.value,
                      });
                    }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </FormGroup>
              </Col>
              <Col sm={3}>
                <FormGroup>
                  <Label>Entry No</Label>
                  <input
                    type="text"
                    required
                    value={param.entry_no}
                    className="form-control h-auto py-2 px-6"
                    name="entry_no"
                    disabled={isView || id != null}
                    onChange={(e) => setParam({ ...param, entry_no: e.target.value })}
                    ref={register}
                  />
                </FormGroup>
              </Col>
              <Col sm={12}>
                <FormGroup>
                  <Label>Remarks</Label>
                  <input
                    type="text"
                    value={param.remarks}
                    className="form-control h-auto py-2 px-6"
                    name="remarks"
                    disabled={isView}
                    onChange={(e) => setParam({ ...param, remarks: e.target.value })}
                    ref={register}
                  />
                </FormGroup>
              </Col>
            </Row>

            <Row>
              <Col sm={12}>
                <Table bordered>
                  <thead>
                    <tr>
                      <th>Product Code</th>
                      <th>Product</th>
                      <th>Size</th>
                      <th>Color</th>
                      <th>Image</th>
                      <th>Qty</th>
                      {/* {param.status.toUpperCase() == "DONE" || param.status.toUpperCase() == "CANCEL" ? null : (
                        <th>
                          Action &nbsp;
                          <input
                            type="checkbox"
                            checked={selectAll}
                            onChange={handleSelectAll}
                          /> 
                        </th>
                      )} */}
                      {param.status.toUpperCase() !== "DONE" && (
                        <th>
                          Action &nbsp;
                          <input
                            type="checkbox"
                            checked={selectAll}
                            disabled={param.status.toUpperCase() === "CANCEL" || isView}
                            onChange={handleSelectAll}
                          />
                        </th>
                      )}
                    </tr>
                  </thead>
                  <tbody>
                    {checkObject(stockAcceptanceproducts)
                      ? null
                      : stockAcceptanceproducts.map((obj, i) => {
                        return (
                          <tr key={i}>
                            <td>
                              ({i + 1}) {obj.product_code}
                            </td>
                            <td>{obj.product}</td>
                            <td>{obj.size_length}</td>
                            <td>{obj.color}</td>
                            <td>
                              <img
                                src={
                                  obj.isImageUrl === true || obj.isImageUrl === "true"
                                    ? obj.image_path
                                    : obj.url_image + obj.image_path
                                }
                                width="36px"
                                alt=""
                              />
                            </td>
                            <td>{obj.transfer_qty}</td>
                            {/* {param.status.toUpperCase() == "DONE" || param.status.toUpperCase() == "CANCEL" ? null : (
                                <td>
                                  <input
                                    type="checkbox"
                                    checked={obj.accept || false}
                                    onChange={(e) => {
  let tempArry = [...stockAcceptanceproducts];
  tempArry[i].accept = e.target.checked;

  setstockAcceptanceproducts(tempArry);

  const allSelected =
    tempArry.length > 0 &&
    tempArry.every(item => item.accept);

  setSelectAll(allSelected);
}}
                                  />
                                </td>
                              )} */}
                            {param.status.toUpperCase() !== "DONE" && (
                              <td>
                                <input
                                  type="checkbox"
                                  checked={obj.accept || false}
                                  disabled={
                                    param.status.toUpperCase() === "CANCEL" ||
                                    obj.locked ||
                                    isView
                                  }
                                  onChange={(e) => {
                                    let tempArry = [...stockAcceptanceproducts];

                                    tempArry[i].accept = e.target.checked;

                                    setstockAcceptanceproducts(tempArry);

                                    const allSelected =
                                      tempArry.filter(x => !x.locked).length > 0 &&
                                      tempArry.filter(x => !x.locked).every(x => x.accept);

                                    setSelectAll(allSelected);
                                  }}
                                />
                              </td>
                            )}
                          </tr>
                        );
                      })}
                  </tbody>
                </Table>
              </Col>
            </Row>
            {success ? <Alert color="success">Saved Successfully</Alert> : null}
            {successDelete ? <Alert color="danger">Entry deleted</Alert> : null}
          </div>
          <div className="card-footer text-right">
            <a href="/branch/stock-acceptance" className="btn btn-secondary mr-2">
              {isView ? "Back" : "Cancel"}
            </a>
            {param.status.toUpperCase() == "DONE" || param.status.toUpperCase() == "CANCEL" || isView ? null : (
              <button type="submit" className="btn btn-primary ">
                Submit
              </button>
            )}
          </div>
        </div>
      </Form>
    </>
  );
};

export default AddStockacceptance;

